// extracted by mini-css-extract-plugin
export default {"LeaderboardsWrapper":"LeaderBoardsModal_LeaderboardsWrapper__dWqmu","LeaderboardsHeading":"LeaderBoardsModal_LeaderboardsHeading__tzBW7"};